(function () {
  'use strict';

  function cartHasHelmet() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return cart.items.some(function (item) {
          return Array.isArray(item.tags)
            ? item.tags.includes('made-to-order-helmet')
            : (item.tags || '').split(', ').includes('made-to-order-helmet');
        });
      });
  }

  function hideAcceleratedButtons() {
    var selectors = [
      '.shopify-payment-button',
      '.dynamic-checkout__content',
      '[data-shopify="payment-button"]',
      '.additional-checkout-buttons'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.display = 'none';
      });
    });
  }

  function init() {
    if (!window.location.pathname.includes('/cart')) return;

    cartHasHelmet().then(function (hasHelmet) {
      if (hasHelmet) { hideAcceleratedButtons(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
